export interface Asset {
  category: string
  benefits: string[]
}

export const assets = [
  {
    category: 'full_pass',
    benefits: [
      'In-person access to all content areas of the event',
      'In-person and digital networking with other participants',
      'In-person and digital access to the Expo.Logística booths',
      'Unlimited access to the event\'s digital platform',
      '90-day access to recorded lectures, available starting August 24, 2026',
      'Coffee break and cocktail reception on August 19 and 20',
      "VIP Lunch on August 19 and 20"
    ],
  },
  {
    category: 'full_content',
    benefits: [
      'In-person access to all content areas of the event',
      'In-person and digital networking with other participants',
      'In-person and digital access to the Expo.Logística booths',
      'Unlimited access to the event\'s digital platform',
      '90-day access to recorded lectures, available starting August 24, 2026',
      'Coffee break and cocktail reception on August 19 and 20',
    ],
  },
  {
    category: 'digital',
    benefits: [
      'Access to recorded classes for 90 days, which will be available after August 24, 2026.',

    ],
  },
]

export function assetCategory(ticketCategory: string) {
  const asset = assets.find((asset) => asset.category === ticketCategory)

  if (!asset) return {} as Asset

  return asset
}